import { cn } from "@/shared/lib";

// Оценка, как в контракте находок (`FindingSeverity`): хорошо, можно лучше, плохо.
export type Severity = "good" | "warn" | "bad";

// `neutral` — без оценки: редкий выбор, нет данных для сравнения.
const GLYPHS: Record<Severity | "neutral", string> = {
  good: "✓",
  warn: "!",
  bad: "×",
  neutral: "–",
};

const COLORS: Record<Severity | "neutral", string> = {
  good: "bg-good",
  warn: "bg-warn",
  bad: "bg-bad",
  neutral: "bg-neutral",
};

type SeverityDotProps = {
  severity: Severity | "neutral";
  className?: string;
};

// Цветной кружок с глифом, как в макете. Декоративный: смысл передаёт текст рядом.
export const SeverityDot = ({ severity, className }: SeverityDotProps) => (
  <span
    aria-hidden="true"
    data-severity={severity}
    className={cn(
      "inline-flex size-[22px] shrink-0 items-center justify-center rounded-full text-[13px] leading-none font-bold text-background",
      COLORS[severity],
      className,
    )}
  >
    {GLYPHS[severity]}
  </span>
);
